import { format } from 'date-fns'

export function formatDate(dateString: string): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }
  return new Intl.DateTimeFormat('ja-JP', options).format(new Date(dateString))
}

export function formatDateTime(date: any, pattern = 'yyyy/MM/dd HH:mm'): string {
  if (date) {
    return format(new Date(date), pattern)
  } else {
    return ''
  }
}

const withZeroSeconds = (date: Date): Date => {
  const normalized = new Date(date)
  normalized.setSeconds(0, 0)
  return normalized
}

/** お知らせ保存API用（yyyy/MM/dd HH:mm:ss、秒は00固定） */
export function formatNotificationDateTime(date: Date): string {
  return format(withZeroSeconds(date), 'yyyy/MM/dd HH:mm:ss')
}

/** OTACメンテナンススケジュール保存API用（YYYY-MM-DDTHH:mm:ss、秒は00固定） */
export function formatOtacMaintenanceDateTime(date: Date): string {
  return format(withZeroSeconds(date), "yyyy-MM-dd'T'HH:mm:ss")
}
